const module = {
  firestorePath: 'listings/{listingId}',
  firestoreRefType: 'doc', // or 'doc'
  moduleName: 'listingDoc',
  statePropName: 'data',
  namespaced: true, // automatically added

  sync: {
    defaultValues: {
      id: '',
      logoUrl: '',
      thumbnailUrl: '',
      bannerUrl: 'https://ik.imagekit.io/jogjabagus/default-listing-banner_o9x5WJavQ.jpg',
      name: '',
      titleId: '',
      titleEn: '',
      excerptId: '',
      excerptEn: '',
      descriptionId: '',
      descriptionEn: '',
      category: {
        subcategory: {}
      },
      owner: {},
      saler: {},
      sosmedLinks: {},
      status: 'Active',
      workHour: {},
      email: '',
      address: '',
      phones: [],
      hitCount: {},
      isTopList: false,
      dateRegister: null,
      dateRenewal: null,
      isDeleted: false,
      price: 0,
      priceRenewal: 0,
    }
  },

  // this object is your store module (will be added as '/myModule')
  // you can also add state/getters/mutations/actions
  state: {},
  getters: {
    data: state => state.data
  },
  mutations: {},
  actions: {},
}

export default module
